import React, { Component } from "react";
import Collapse from "../../../../shared/Collapse/Collapse";
import MyPassengersTable from "./MyPassengersTable";
import MyPassengersAverage from "./MyPassengersAverage";
import { formatCurrency, intFormat } from "../../../../../js/shared/utils";
import { withGetScreen } from "react-getscreen";
import { SCREEN_BREAKPOINT } from "../../../shared/screen-breakpoints";
import * as PropTypes from "prop-types";

class MyPassengersLogListItem extends Component {
	render() {
		let {
			log,
			showAverageMiles,
			headerIconClassName,
			headerDescription,
			headerDescriptionSmall,
			isMobile,
			isTablet
		} = this.props;

		return (
			<div
				className={`my-passengers-log-list-item${log.passengers.length === 0 ? " my-passengers-log-list-item--no-passengers" : ""
					}`}
			>
				<Collapse
					className="my-passengers-log-list-item__collapse"
					arrowPrimaryColor={true}
					headerchildren={
						<div className="my-passengers-log-list-item__collapse__header">
							{headerIconClassName && <i className={headerIconClassName} />}
							<div className="my-passengers-log-list-item__collapse__header__data">
								<div className="my-passengers-log-list-item__collapse__header__data__general">
									<div className="my-passengers-log-list-item__collapse__header__data__general--quantities">
										{log.miles !== null && log.miles >= 0 && (
											<div>
												<span>Qtd. de milhas: </span>
												<span className="values">{intFormat(parseInt(log.miles))}</span>
											</div>
										)}

										{log.price !== null && log.price >= 0 && (
											<div>
												<span>Preço: </span><span className="values">{formatCurrency(log.price)}</span>
											</div>
										)}
									</div>

									<div
										className={`my-passengers-log-list-item__collapse__header__data__general--description${headerDescriptionSmall
											? " my-passengers-log-list-item__collapse__header__data__general--description--small"
											: ""
											}`}
									>
										{headerDescription}
									</div>
								</div>
								{showAverageMiles && (isMobile() || isTablet()) && (
									// <div className="my-passengers-log-list-item__collapse__header__alert-average-changed">
									<MyPassengersAverage average={log.averageMiles} />
								)
									// </div>
								}
								{log.hadAvergeChange && log.miles >= 60000 && (
									<div className="my-passengers-log-list-item__collapse__header__alert-average-changed">
										<div className="my-passengers-log-list-item__collapse__header__alert-average-changed--icon" />
										<div className="my-passengers-log-list-item__collapse__header__alert-average-changed--text">
											<span>Média alterada para{" "}</span>
											<span className="values">{intFormat(parseInt(log.averageMiles))} milhas por passageiro</span>
										</div>
									</div>
								)}
							</div>
							{showAverageMiles && log.miles >= 60000 && !isMobile() && !isTablet() && (
								<MyPassengersAverage average={log.averageMiles} />
							)}
						</div>
					}
					content={
						log.passengers.length > 0 ? (
							<div className="row">
								<div className="col-xs-16">
									<div className="my-passengers-log-list-item__collapse__content">
										<MyPassengersTable passengers={log.passengers} />
									</div>
								</div>
							</div>
						) : null
					}
				/>
			</div>
		);
	}
}

export default withGetScreen(MyPassengersLogListItem, {
	mobileLimit: SCREEN_BREAKPOINT.sm,
	tabletLimit: SCREEN_BREAKPOINT.lg,
	shouldListenOnResize: true
});

MyPassengersLogListItem.propTypes = {
	log: PropTypes.object,
	showAverageMiles: PropTypes.bool,
	headerIconClassName: PropTypes.string,
	headerDescription: PropTypes.string,
	headerDescriptionSmall: PropTypes.bool
};

MyPassengersLogListItem.defaultProps = {
	log: {
		passengers: []
	},
	headerDescriptionSmall: true,
	showAverageMiles: null,
	headerIconClassName: null,
	headerDescription: "Description"
};
